import {
  useCurrencyFormatter,
  useDateFormatter,
} from '@mint-lib/formatting-hooks';
import { useTranslation } from '@mint-lib/i18n';
import { Calendar, Money } from '@mint-lib/icons';
import { Card, typographyVariants } from '@mint-lib/tw-components';
import { parseISO } from 'date-fns';

import { useMediaPlan } from '../../../../api/queries/useMediaPlan.js';
import type { Activity } from '../../../../types/activity.types.js';

type ActivityPreviewCardProps = {
  activity: Activity;
};

export const ActivityPreviewCard = ({ activity }: ActivityPreviewCardProps) => {
  const { t } = useTranslation('@myn/planning_v2');
  const { data: mediaPlan } = useMediaPlan();

  const { formattedDateRange } = useDateFormatter(
    parseISO(activity.dateFrom),
    parseISO(activity.dateTo),
  );

  const currencyFormatter = useCurrencyFormatter();
  const formattedBudget =
    activity.budget && mediaPlan
      ? currencyFormatter.format(Number(activity.budget), {
          currency: mediaPlan.currency,
        })?.formatted
      : null;

  return (
    <Card
      variant="outlined"
      className="w-full"
      contentClassName="flex flex-col gap-4"
    >
      <div className="flex items-center gap-2">
        <Calendar className="shrink-0 fill-icon-secondary" />
        <span className={typographyVariants({ variant: 'h6' })}>
          {t('Activity dates:')}
        </span>
        <span className={typographyVariants({ variant: 'bodyShort01' })}>
          {formattedDateRange}
        </span>
      </div>
      <div className="flex items-center gap-2">
        <Money className="shrink-0 fill-icon-secondary" />
        <span className={typographyVariants({ variant: 'h6' })}>
          {t('Activity budget:')}
        </span>
        <span className={typographyVariants({ variant: 'bodyShort01' })}>
          {formattedBudget ?? '-'}
        </span>
      </div>
    </Card>
  );
};
